export default __webpack_public_path__ + "static/media/Prahis.e6756642.jpeg";